module.exports = __webpack_public_path__ + "img/sensor-alert.dfa58b82.png";